import { Box } from '@opendoor/bricks/core';
import { trackEvent } from '@opendoor/shared-fe/build/analytics';

import Question from 'src/components/common/Question';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

type InputQuestionProps = {
  answers: { [key: string]: any };
  questionTitle: string;

  // Optional:
  errorMessage?: string;
  showInfoCard?: boolean;
  pageHasError?: boolean;
  question: FlowQuestion;
};

const InputQuestion: React.FC<InputQuestionProps> = ({
  answers,
  errorMessage,
  pageHasError,
  question,
  questionTitle,
  showInfoCard,
}) => {
  return (
    <Box mb={showInfoCard ? [6, 7] : [6, 0]}>
      <Question
        answers={answers}
        question={question}
        questionTitle={questionTitle}
        errorMessage={errorMessage}
        showInfoCard={showInfoCard}
        pageHasError={pageHasError}
        trackEvent={trackEvent}
      />
    </Box>
  );
};

export default InputQuestion;
